
import computed from '../../middlewares/computed'
import transform from '../../middlewares/transform'
import elementRef from '../../middlewares/elementRef'
import { middlewarePropUIChanges } from "../../middlewares/propUIChanges";
import elementRefList from '../../middlewares/elementRefList';
import initElementRef from '../../middlewares/useElementRef';
import initElementRefList from '../../middlewares/useElementRefList';

/**
 * 
 * @param {import('../../t.d').ZoneWrapper} zoneWrapper 
 * @returns {Object.<string,Function>}
 */
const useInjectMiddleware = (zoneWrapper) => {
    const injectMiddleware = zoneWrapper.injectMiddleware;
    const { useZoneComputed } = injectMiddleware(computed());

    /** @type {{ useZoneTransform: (propKey: string, cb: (value:any) => any) => void}} */
    const { useZoneTransform } = injectMiddleware(transform());

    /**@type {{useElementRef: () => {element: HTMLElement | null}}} */
    // const { useElementRef } = injectMiddleware(elementRef());
    // const { useElementRefList } = injectMiddleware(elementRefList());

    const useElementRef = initElementRef(zoneWrapper.zoneProp);
    const useElementRefList = initElementRefList(zoneWrapper.zoneProp);

    // const f = middlewarePropUIChanges();
    // injectMiddleware(f);

    return {
        useZoneComputed,
        useZoneTransform,
        useElementRef,
        useElementRefList
    }
}

export default useInjectMiddleware;